import * as React from "react";
import { useTheme } from "styled-components";

import { style, Icon } from "./Symbolicons";

const CalendarSchedule = (props: Icon): React.ReactElement => {
  const theme = useTheme();

  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      style={{ ...style(props.size, props.height), ...props.style }}
      className={props.className}
    >
      <path
        d="M16.002 12.301h-1.95M16.002 10.352v1.95M7.998 12.301a4.412 4.412 0 0 1 7.75 0M7.498 16.002h1M11.5 16.002h1M11.5 16.002h1M15.501 16.002h1M7.498 2.996v3.001M16.502 2.996v3.001"
        stroke={props.color || theme.palette.grey600}
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x={2.996}
        y={4.497}
        width={18.008}
        height={16.507}
        rx={3}
        stroke={props.color || theme.palette.grey600}
        strokeWidth={1.25}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export { CalendarSchedule };
